import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../shared/buttons/button';
import ConfirmModal from '../shared/modals/confirm-modal';

export type ActionsPropsType = {
  hasNextPage: boolean | undefined;
  onFetchNext: any;
};

function Actions({ hasNextPage, onFetchNext }: ActionsPropsType) {
  const [showFinishModal, setShowFinishModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className='grid grid-cols-2 gap-2'>
      <div className='col-span-2 flex flex-col gap-2'>
        {hasNextPage && (
          <Button
            color='green'
            content='بارگذاری بقیه سوالات'
            size='lg'
            onClick={onFetchNext}
            className='mx-auto w-2/3'
          />
        )}
        <Button
          color='yellow'
          content='اتمام تحلیل آزمون'
          size='lg'
          onClick={() => setShowFinishModal(true)}
          className='mx-auto w-2/3'
        />
      </div>
      {showFinishModal && (
        <ConfirmModal
          showModal={showFinishModal}
          onConfirm={async () => {
            setShowFinishModal(false);
            navigate('/results');
          }}
          onCancel={() => setShowFinishModal(false)}
        >
          <div className='flex flex-col gap-2'>
            {hasNextPage && <p className='text-red-500'>هنوز کل صفحات رو بررسی نکرده‌اید.</p>}
            <p>آیا از اتمام تحلیل آزمون مطمئن هستید؟</p>
          </div>
        </ConfirmModal>
      )}
    </div>
  );
}

export default Actions;
